import { MetaData } from "../interfaces/config/metaData";

/**
 * Default description used for meta data.
 *
 * @constant {string}
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const description =
  "Direct and develop your mobile application, software or website project with the help of the most innovative and nimble talents on the market.";

/**
 * Metadata for different pages in the application.
 *
 * @type {MetaData}
 */
const metaData: MetaData = {
  home: {
    title:
      "Timber Place | Premium Land Investments & Real Estate Opportunities",
    description:
      "Find your dream property with Timber Place's expertly curated selection of premium lands. Explore our portfolio for exceptional investment opportunities.",
    keywords:
      "real estate, land for sale, property investment, premium land, home building, land development",
  },
  lands: {
    title: "Land For Sale | Premium Properties | Timber Place Real Estate",
    description:
      "Browse our exclusive collection of land for sale. Find the perfect residential lot, commercial property, or investment opportunity in prime locations.",
    keywords:
      "land for sale, property listings, real estate, investment properties, residential land, commercial land",
  },
  landDetails: {
    title: "Property Details | Premium Land For Sale | Timber Place",
    description:
      "Discover detailed information about this exceptional property. View specifications, location details, and high-quality images of this premium land for sale.",
    keywords:
      "property details, land specifications, real estate listing, lot size, property features, land investment",
  },
  notFound: {
    title: "Page Not Found | Timber Place Real Estate",
    description:
      "The page you're looking for doesn't exist. Return to our homepage to explore premium lands and real estate opportunities.",
    keywords: "page not found, 404 error, Timber Place real estate",
  },
};

export default metaData;
